/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/no-unresolved */
import {
  Theme04CapturedCard,
  NoDataFound,
  GlobalLoader,
  RippleEffect,
  Loader,
  CommonButton,
} from "components";
import CapturedModel from "components/UiElement/Theme01/CapturedModel";
import {  useState } from "react";
import { Container, Row } from "react-bootstrap";

function CapturedSection({
  getPhotoData,
  loading,
  capturedData,
  photoData,
  t,
  onShowMore,
  count,
}) {
  const [showModalImageMemory, setModalImageMemory] = useState(false);
  // const {/id } = useParams();


  const openImageModal1 = (memorialId) => {
    setModalImageMemory(!showModalImageMemory);
    getPhotoData(memorialId);
  };

  const handleCloseModalImageMemory = () => {
    setModalImageMemory(false);
  };
  return (
    <>
      {loading ? (
        <GlobalLoader />
      ) : (
        <Container>
          <div className="commonHead text-center">
            <div className="commonHead_sub">{t("text.theme.photographs")}</div>
            <h2 className="commonHead_title mb-0">
              {t("text.theme.capturedMemories")}
            </h2>
          </div>
          <div>
            {capturedData?.length > 0 ? (
              <Row className="g-3">
                {capturedData.map((item) => {
                  return (
                    <Theme04CapturedCard
                      item={item}
                      openImageModal1={openImageModal1}
                    />
                  );
                })}
              </Row>
            ) : (
              <NoDataFound />
            )}
          </div>
          <RippleEffect extraClassName="justify-content-center mt-sm-3 w-100 py-1">
            <div className="text-center">
              {loading ? (
                <Loader />
              ) : (
                count > capturedData?.length && (
                  <CommonButton
                    variant="light"
                    onClick={(e) => {
                      e.preventDefault();
                      onShowMore();
                    }}
                  >
                    Load More
                  </CommonButton>
                )
              )}
            </div>
          </RippleEffect>
        </Container>
      )}
      <CapturedModel
        handleCloseModal1={handleCloseModalImageMemory}
        showModal1={showModalImageMemory}
        photoData={photoData}
      />
    </>
  );
}

export default CapturedSection;
